/* Format review counts with thousands separators ("1536 reviews" ->
   "1,536 reviews"). Judge.me builds its badges/widgets client-side with raw
   numbers, so this formats digit runs of 4+ inside Judge.me elements after
   they render, and re-applies whenever the widget re-renders (pagination,
   filtering). Writes only when the text actually changes, so the observer
   settles after one pass. */
(function () {
  var SELECTOR = [
    '.jdgm-prev-badge__text',
    '.jdgm-rev-widg__summary-text',
    '.jdgm-paginate__page-info',
    '.jdgm-all-reviews__body-text',
    '.jdgm-histogram__frequency'
  ].join(',');

  function withCommas(text) {
    return text.replace(/\d{4,}/g, function (n) {
      return Number(n).toLocaleString('en-US');
    });
  }

  function formatAll() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var formatted = withCommas(el.textContent);
      if (formatted !== el.textContent) el.textContent = formatted;
    });
  }

  /* Debounced: apps mutate the DOM hundreds of times during load, and a
     synchronous sweep per mutation was ~185ms of main-thread work (worse
     on slow devices). Coalesce each mutation burst into one idle-time
     sweep — formatting lands a frame later at most. */
  var scheduled = false;
  function scheduleFormat() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      formatAll();
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 500 });
    } else {
      window.setTimeout(run, 50);
    }
  }

  new MutationObserver(scheduleFormat).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatAll);
  } else {
    formatAll();
  }
})();
